

import React, { Component } from "react";
//import { PropTypes,func } from "prop-types";

import { connect } from "react-redux";
import {  reduxForm, propTypes } from 'redux-form'
import {
  Row,
  Col,
  Panel,
  FormControl,
  //InputGroup
} from "react-bootstrap"
import { PropTypes } from "prop-types"
import { URL } from '../../../config'
//import userManager from '../../../userManager'
//import ContentWrapper from "../../layout/ContentWrapper"
import { getRequest } from '../../../utils/httpRequest'
import { videoblue,green,warning } from '../../../utils/constants'
import ExceptionType from './ExceptionType'


class ReconcileEvent extends Component {
  static propTypes = {
    ...propTypes
  }
  constructor(props)
  {
    super(props)
    this.state = {
     exceptions:[],
     gettingExceptions:true,
     eventId:-1
    }
    this.getExceptions = this.getExceptions.bind(this)
    this.refreshExceptions = this.refreshExceptions.bind(this)
  }
  ReconcileBy =
  {
    System:'system',
    Score:'score'
  }
  handleDivisionChange= (event) => {
    const division = event.target.value
    console.log('handleReconciliationTypeChange',division)
  }
  handleSearchValueChange = () => {
    /*  this.setState({
      addNewEventMode: false
    }) */
  }
  refreshExceptions(eventId)
  {
    const { exceptionType } = this.props
     this.setState({ exceptions:[], gettingExceptions:true })
     this.getExceptions(eventId,exceptionType)
  }
  getExceptions(eventId,exceptionType)
  {
    const exceptionsendpoint = `${eventId}/exceptions/${exceptionType}`
    const token = this.props.oidc.user.access_token
    const  exceptionsURL =  `${URL.event}/${exceptionsendpoint}` 
    const _this = this
    
    getRequest(exceptionsURL,'json',token).then(function(response){
      _this.setState({ 
        exceptions:response.data,
        gettingExceptions:false,
        eventId:eventId,
        gotExceptions:true
      })
    })
  }
  setModes = (neweventmode, searchresultmode, freetextsearch=null,searchby=null) => {
    this.setState({
      freeTextSearch: freetextsearch !== null ? freetextsearch : this.state.freeTextSearch,
      searchBy: searchby !== null ? searchby : this.state.searchBy
    })
  }
  
  setSearchTextField = () => {
      const fldtype = 'text'
      return (<FormControl type={fldtype} placeholder='Enter value' style={{ minWidth:'220px' }}/>)
  }
  setSelectValues = () => {
    const attrs = {
      name:'searchvalue',
      componentClass:'select',
      onChange: this.handleSearchValueChange ,
      style:
       { 
         minWidth:"220px" 
       }
    }
    switch(this.state.searchBy)
      {
        case this.SearchBy.Status:
        {
          return(
            <FormControl {...attrs} defaultValue="all">
              <option value="all">Select School</option> 
              <option value="pendingapproval">Purdue</option>  
            </FormControl>
          )
        }
      }    
  }
  
  render()
    {
      const { exceptions,gettingExceptions } = this.state
      const { eventId,action,exceptionType } = this.props
      const _this = this
      const numberOfExceptions = exceptions.length
      //console.log('ReconcileEvent this.state.eventId, eventId, action,exceptionType',this.state.eventId, eventId, action,exceptionType)
      const hasExceptions = exceptions.length > 0 ? true:false
      
      if(this.state.eventId != eventId)
      {
        this.getExceptions(eventId,exceptionType)
      }   
      let eventName = ''
      let startDate = ''
      let endDate = ''
     
      if(hasExceptions)
      {
        eventName = exceptions[0].eventName
        startDate = exceptions[0].startDate
        endDate   = exceptions[0].endDate
      }
     
        return (
          <div sm={6} style={{ marginLeft:'1%',marginRight:'1%' ,maxWidth:'85%'  }}>
            <Panel>
            { 
              gettingExceptions && 
              (<span style={{ color:green, fontSize:'18px' }}><i className='fa fa-spinner fa-spin' aria-hidden='true'/>&nbsp;...Getting event exceptions</span>)
            }
            {
              !gettingExceptions && 
              (
                <div className="content-heading" style={{ color:videoblue, fontWeight:'bold',fontSize:'16px' }}>
                  {
                    hasExceptions && (<span style={{ paddingRight:'20px' }}>{eventName},&nbsp;{startDate}&nbsp;-&nbsp;{endDate}&nbsp;&nbsp;</span>)
                  }
                  {
                    (action == 'Reconcile') && 
                    (<span style={{ color:warning,fontWeight:'normal' }}>
                      <i className='fa fa-info-circle' aria-hidden='true'/>&nbsp;&nbsp;This event generated {numberOfExceptions} exceptions
                    </span>)
                  }
              </div>
              )
            }
            <div style={{ marginTop:'15px' }}>
              <Row>
                <Col sm={12}>
                  {
                    exceptions.map(function(exception, index) {
                      return (<ExceptionType exception={exception} index={index + 1} key={index} action={action} exceptionUpdated={_this.refreshExceptions} />)
                    })
                  }
                </Col>
              </Row> 
            </div>
          </Panel>
        </div>
        )
    }
}
ReconcileEvent.propTypes = {
  oidc: PropTypes.object,
  dispatch:PropTypes.func,
  reset:PropTypes.func,
  eventId:PropTypes.number,
  action:PropTypes.string,
  eventChanged:PropTypes.bool,
  exceptionType:PropTypes.string
}
const mapDispatchToProps = () => ({})
const mapStateToProps = ({  oidc }) => {
	return {
		oidc: { ...oidc }
	}
}
export default reduxForm({
  form:'event'
})(connect(mapStateToProps,mapDispatchToProps)(ReconcileEvent))




// WEBPACK FOOTER //
// ./src/components/pages/Event/ReconcileEvent.js